import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CategoryTile } from "@/components/CategoryTile";

function flattenTree(roots, products) {
  const populatedCategoryIds = new Set();
  for (const product of products) {
    populatedCategoryIds.add(product.subcategory_id || product.category_id);
  }

  return roots.flatMap((root) =>
    root.children?.length
      ? root.children
        .map((child) => ({ ...child, parent_slug: root.slug }))
      : populatedCategoryIds.has(root.id) ? [root] : [],
  );
}

export function StoreCategoryStrip({ inline = false, showHeading = true }) {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const { data } = await api.get("/categories/strip");
        if (mounted) setCategories(data);
      } catch (stripError) {
        try {
          const [{ data: tree }, { data: products }] = await Promise.all([
            api.get("/categories/tree"),
            api.get("/products", { params: { limit: 1000 } }),
          ]);
          if (mounted) setCategories(flattenTree(tree, products));
        } catch (treeError) {
          console.error("category strip load failed", stripError, treeError);
        }
      }
    };
    load();
    return () => { mounted = false; };
  }, []);

  if (categories.length === 0) return null;

  return (
    <section data-testid="store-category-strip" className={`${inline ? "mt-4" : ""} border-b border-hyd-border bg-hyd-bg`}>
      <div className={`${inline ? "" : "max-w-6xl mx-auto"} px-4 py-2`}>
        {showHeading && <h2 className="font-display text-base sm:text-lg font-bold mb-2">Shop by category</h2>}
        <div className="flex gap-3 overflow-x-auto snap-x-mandatory pb-1 fade-right-mask">
          {categories.map((category) => (
            <CategoryTile
              key={category.id}
              category={category}
              to={category.parent_slug
                ? `/${category.parent_slug}/${category.slug}`
                : `/category/${category.slug}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
